import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


let tripleImageContainers = '.triple-image.scroll'

if (tripleImageContainers) {

  ScrollTrigger.matchMedia({
  "(min-width: 800px)": function() {

  gsap.utils.toArray(tripleImageContainers).forEach((container) => {
    let scrollBottom = container.querySelectorAll('.triple-image__first, .triple-image__third, .scrollToBottom')
    let scrollTop = container.querySelectorAll('.triple-image__second, .scrollToTop')


    gsap.to(scrollBottom, {
      yPercent: 50,
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "-50%",
        end: "150%",
        scrub: true
      }, 
    });

    gsap.to(scrollTop, {
      yPercent: -50,
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "-50%",
        end: "150%",
        scrub: true
      }, 
    });

  })

}})

}